import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <Section data-id="element-84">
      <div className="max-w-3xl mx-auto text-center" data-id="element-85">
        <div className="flex justify-center mb-8" data-id="element-86">
          <div className="w-24 h-24 bg-cta/10 rounded-full flex items-center justify-center border border-cta/30" data-id="element-87">
            <ShieldCheck className="w-12 h-12 text-cta" data-id="element-88" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-89">
          🛡️ GARANTÍA DE 7 DÍAS
        </h2>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed bg-night-800 p-8 md:p-12 rounded-3xl border border-night-700" data-id="element-90">
          <p data-id="element-91">Probá el sistema durante 7 días.</p>
          <p data-id="element-92">
            Si no te sirve, te devolvemos el dinero. Sin preguntas. Sin vueltas.
          </p>

          <div className="h-px w-full bg-night-700 my-8" data-id="element-93" />

          <p className="text-gray-400 italic" data-id="element-94">
            "La mayoría nota diferencia en las primeras 3 noches. 7 días son más
            que suficientes."
          </p>
        </div>
      </div>
    </Section>;
};